import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import './CancelMakeUpSessionPage.css';
import ConfirmBox from '../../../components/ConfirmBox/ConfirmBox';
import AlertBox from '../../../components/AlertBox/AlertBox';

// Redux actions
import CancelMakeActions from '../../../redux/CancelMakeRedux';
import GetMakeUpSessionActions from '../../../redux/GetMakeUpSessionRedux';
import UpdateMakeActions from '../../../redux/UpdateMakeRedux';

// Icons
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow-left.svg';
import { t } from 'i18next';

interface CancelMakeUpSessionPageProps {
  navigate: NavigateFunction;
  // Redux props
  currentSettings: any;
  cancelMakeFetching: boolean;
  cancelMakeSuccess: boolean;
  cancelMakeError: boolean;
  status: any;
  getMakeUpSessionFetching: boolean;
  getMakeUpSessionSuccess: boolean;
  getMakeUpSessionError: boolean;
  leavedatacancel: any[];
  updateMakeFetching: boolean;
  updateMakeSuccess: boolean;
  updateMakeError: boolean;
  makedata: any;
  // Redux actions
  cancelMake: (make_id: string) => void;
  getMakeUpSession: (children_id: string) => void;
  updateMake: (make_id: string, make: any) => void;
}

interface CancelMakeUpSessionPageState {
  selected: string | null;
  leave_id: string | null;
  status: string | null;
  is_started: boolean | null;
  therapist_leave_id: string | null;
  confirmBoxPopup: boolean;
  alertBoxPopup: boolean;
  alertBoxMessage: string;
}

class CancelMakeUpSessionPage extends Component<CancelMakeUpSessionPageProps, CancelMakeUpSessionPageState> {
  constructor(props: CancelMakeUpSessionPageProps) {
    super(props);
    
    // Get route parameters (equivalent to React Native's getParam)
    const urlParams = new URLSearchParams(window.location.search);
    const categoryId = this.getStateParam('categoryId') || urlParams.get('categoryId');
    
    // Get children_id from currentSettings
    const children_id = this.getChildrenId();
    
    // Fetch make-up sessions on component mount
    if (children_id) {
      this.props.getMakeUpSession(children_id);
    }
    
    this.state = {
      selected: null,
      leave_id: null,
      status: null,
      is_started: null,
      therapist_leave_id: null,
      confirmBoxPopup: false,
      alertBoxPopup: false,
      alertBoxMessage: '',
    };
  }

  componentDidMount() {
    console.log('CancelMakeUpSessionPage mounted');
  }

  componentDidUpdate(prevProps: CancelMakeUpSessionPageProps) {
    // Handle cancel make success/error
    if (!this.props.cancelMakeFetching) {
      if (
        this.props.cancelMakeSuccess &&
        this.props.cancelMakeSuccess !== prevProps.cancelMakeSuccess
      ) {
        if (this.props.status?.success == false) {
          if (this.props.status?.message !== " ") {
            this.setState({ alertBoxPopup: true, alertBoxMessage: this.props.status?.message });
            // this.props.navigate('/calendar');
          } else {
            this.setState({ alertBoxPopup: true, alertBoxMessage: t?.('make-up-session:cancel-leave-failed') || 'Cancel leave failed! Something went wrong' });
            // alert('Cancel leave failed! Something went wrong');
            // this.props.navigate('/calendar');
          }
        } else if (this.props.status?.success == true) {
          this.setState({ alertBoxPopup: true, alertBoxMessage: t?.('make-up-session:cancel-make-up-session-successfully') || 'Cancel make up session successfully' });
          // alert('Cancel make up session successfully');
          // this.props.navigate('/calendar');
        }
      }

      if (
        this.props.cancelMakeError &&
        this.props.cancelMakeError !== prevProps.cancelMakeError
      ) {
        alert('Request submitted failed! Something went wrong');
      }
    }
  }

  getChildrenId(): string | null {
    // Try multiple sources for children_id
    let children_id = null;
    
    // 1. Try currentSettings.child.salesforce_contact_id
    if (this.props.currentSettings?.child?.salesforce_contact_id) {
      children_id = this.props.currentSettings.child.salesforce_contact_id;
    }
    
    // 2. Try currentSettings.child.id if salesforce_contact_id is not available
    else if (this.props.currentSettings?.child?.id) {
      children_id = this.props.currentSettings.child.id;
    }
    
    if (!children_id) {
      console.error('CancelMakeUpSessionPage: No valid children_id found');
    }
    
    return children_id;
  }

  getRouteParam(paramName: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  }

  getStateParam(paramName: string): string | null {
    // Get state from navigation history
    const state = (window.history.state as any)?.state;
    return state?.[paramName] || null;
  }

  _onRefresh() {
    const children_id = this.getChildrenId();
    if (children_id) {
      this.props.getMakeUpSession(children_id);
    }
  }

  _onNextPress() {
    const children_id = this.getChildrenId();
    if (!children_id) {
      alert('Unable to proceed. Child information not available.');
      return;
    }

    let make = {
      salesforce_contact_id: children_id,
      leave_id: this.state.leave_id,
      make_id: this.state.selected,
      status: this.state.status,
      isReschedule: true,
      therapist_leave_id: this.state.therapist_leave_id,
    };
    
    console.log("updateMake....", this.state.selected, make);
    
    // Navigate to BookMakeUpSessionScreen for rescheduling using URL params
    const categoryId = this.getStateParam('categoryId') || this.getRouteParam('categoryId');
    const code = this.getStateParam('code') || this.getRouteParam('code');
    const leave_id = this.state.leave_id;
    const therapist_leave_id = this.state.therapist_leave_id;
    const make_id = this.state.selected;
    
    const paramsForUpdateMake = { selected: this.state.selected, make }
    const strParamsForUpdateMake = encodeURI(JSON.stringify(paramsForUpdateMake))

    this.props.navigate(`/calendar/book-make-up-session?categoryId=${categoryId}&code=${code}&leave_id=${leave_id}&therapist_leave_id=${therapist_leave_id}&isReschedule=true&make_id=${make_id}&paramsForUpdateMake=${strParamsForUpdateMake}`);
  }

  cancel() {
    this.setState({ confirmBoxPopup: true });
    /* if (window.confirm("Are you sure to cancel this session?")) {
      if (this.state.selected) {
        this.props.cancelMake(this.state.selected);
      }
    } */
  }
  confirmCancel() {
    if (this.state.selected) {
      this.props.cancelMake(this.state.selected);
    }
  }


  _popUp() {
    if (window.confirm("Are you sure to reschedule this make up request?")) {
      this._onNextPress();
    }
  }

  render() {
    const { selected, is_started } = this.state;
    const { 
      cancelMakeFetching, 
      getMakeUpSessionFetching, 
      getMakeUpSessionSuccess, 
      leavedatacancel,
      updateMakeFetching 
    } = this.props;
    
    const code = this.getStateParam('code') || this.getRouteParam('code');
    const isRescheduleMode = code === "reschedule-a-make-up-session";
    const pageTitle = isRescheduleMode
      ? (t('leave-request-history:select-make-up-session-reschedule') || 'Select make up session reschedule')
      : (t('leave-request-history:select-make-up-session-to-cancel') || 'Select make up session to cancel');
    const nextText = t('common:next') || 'Next';
    const cancelText = t('common:cancel') || 'Cancel';

    return (
      <div className="cancelmakeupsession-page">
        {/* Header */}
        <header className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button 
                className="header-button back-button" 
                onClick={() => this.props.navigate(-1)}
              >
                <ArrowLeftIcon />
              </button>
              <h1 className="header-title">{pageTitle}</h1>
            </div>
            {isRescheduleMode && (
              <div className="header-right">
                <button
                  className="next-button header-button"
                  onClick={() => selected && is_started === false ? this._popUp() : undefined}
                  disabled={!selected || is_started === true}
                >
                  <span className="button-text">{nextText}</span>
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Loading Overlay */}
        {updateMakeFetching && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        {/* Content */}
        <div className="page-content">
          {getMakeUpSessionFetching ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
            </div>
          ) : getMakeUpSessionSuccess && leavedatacancel && Array.isArray(leavedatacancel) && leavedatacancel.length > 0 ? (
            <div className="session-list">
              {leavedatacancel.map((item: any, index: number) => (
                <div key={item.id} className="session-item">
                  <div 
                    className="session-content"
                    onClick={() => {
                      this.setState({
                        selected: item?.id,
                        leave_id: item?.leave_id,
                        status: item?.status,
                        is_started: item?.is_started,
                        therapist_leave_id: item?.therapist_leave_id,
                      });
                    }}
                  >
                    <div className="session-main-info">
                      <h3 className="session-title">
                        Make up session {leavedatacancel?.length - index}
                      </h3>
                      
                      <div className="session-details">
                        <div className="detail-row">
                          <span className="detail-label">Name:</span>
                          <span className="detail-value">{item?.name || ""}</span>
                        </div>
                        
                        <div className="detail-row">
                          <span className="detail-label">Time:</span>
                          <span className="detail-value">
                            {item?.data[0]?.time ? item?.data[0]?.time : ""}
                          </span>
                        </div>
                        
                        {/* Session data details */}
                        {item?.data && Array.isArray(item.data) && item.data.map((sessionData: any, dataIndex: number) => (
                          <div key={dataIndex} className="session-data">
                            <div className="detail-row">
                              <span className="detail-label">Therapist:</span>
                              <span className="detail-value">
                                {sessionData?.therapist ? sessionData?.therapist : ""}
                              </span>
                            </div>
                            
                            <div className="detail-row">
                              <span className="detail-label">
                                {sessionData?.option_schedule == 0
                                  ? "Date"
                                  : sessionData?.option_schedule == 1
                                  ? "Add 15 Minutes before the sessions"
                                  : sessionData?.option_schedule == 2
                                  ? "Add 15 Minutes after the session"
                                  : "Date"
                                }:
                              </span>
                              <span className="detail-value">
                                {sessionData?.date
                                  ? moment(sessionData?.date?.date).format("DD MMMM YYYY")
                                  : ""
                                }
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    {/* Radio Button Selection */}
                    {isRescheduleMode ? (
                      item?.is_started == false ? (
                        <div className="radio-selection">
                          {selected === item?.id ? (
                            <span className="radio-selected"></span>
                          ) : (
                            <span className="radio-unselected"></span>
                          )}
                        </div>
                      ) : null
                    ) : (
                      <div className="radio-selection">
                        {selected === item?.id ? (
                          <span className="radio-selected"></span>
                        ) : (
                          <span className="radio-unselected"></span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : getMakeUpSessionSuccess && leavedatacancel && !Array.isArray(leavedatacancel) ? (
            <div className="no-sessions">
              <p>Make-up sessions data is not in expected format</p>
              <p>Debug: {JSON.stringify(leavedatacancel)}</p>
            </div>
          ) : (
            <div className="no-sessions">
              <p>No make-up sessions available</p>
            </div>
          )}
        </div>

        {/* Cancel Button (only for cancel mode) */}
        {!isRescheduleMode && (
          <div className="action-section">
            <button
              className="cancel-button comman-btn w-100"
              onClick={() => selected != null ? this.cancel() : undefined}
              disabled={selected == null}
            >
              {cancelText}
            </button>
          </div>
        )}

        <ConfirmBox
          title={t?.('make-up-session:confirm') || 'Confirm'}
          message={t?.('make-up-session:confirm-cancel-message') || 'Are you sure to cancel this session?'}
          confirmAction={() => this.confirmCancel()}
          cancelAction={() => this.setState({ confirmBoxPopup: false })}
          isVisible={this.state.confirmBoxPopup}
          onClose={() => {}}
          confirmText={t?.('common:ok') || 'OK'}
          cancelText={t?.('common:cancel') || 'Cancel'}
        />

        <AlertBox
          title={t?.('make-up-session:message') || 'Message'}
          message={this.state.alertBoxMessage}
          isVisible={this.state.alertBoxPopup}
          onClose={() => {}}
          okAction={() => {
            this.props.navigate('/calendar');
          }}
        />
      </div>
    );
  }
}

// Redux mapping
const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
    cancelMakeFetching: state.cancelMake.fetching,
    cancelMakeSuccess: state.cancelMake.success,
    cancelMakeError: state.cancelMake.error,
    status: state.cancelMake.makedata,
    getMakeUpSessionFetching: state.getMakeUpSession.fetching,
    getMakeUpSessionSuccess: state.getMakeUpSession.success,
    getMakeUpSessionError: state.getMakeUpSession.error,
    leavedatacancel: state.getMakeUpSession.leavedatacancel,
    updateMakeFetching: state.updateMake.fetching,
    updateMakeSuccess: state.updateMake.success,
    updateMakeError: state.updateMake.error,
    makedata: state.updateMake.makedata,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    cancelMake: (make_id: string) =>
      dispatch(CancelMakeActions.cancelMakeRequest(make_id)),
    getMakeUpSession: (children_id: string) =>
      dispatch(GetMakeUpSessionActions.getMakeUpSessionRequest(children_id)),
    updateMake: (make_id: string, make: any) =>
      dispatch(UpdateMakeActions.updateMakeRequest(make_id, make)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelMakeUpSessionPage);
